export const SPIN_THE_WHEEL = 'spin_the_wheel';
export const SCRATCHCARD = 'quiz';
